import { createDialog } from '../../util/createDialog';

/** @type {DialogFactory<Partial<{ buttons: import('@mui/material').ButtonProps[] | undefined; onClose: () => void }>>} */
const dialog = createDialog();

export const $$confirmationDialog = {
  ...dialog
};
